module.exports = __webpack_public_path__ + "media/icons/color-select@2x-9cecc13d.png";